import styled from 'styled-components';

import CardRow from 'components/CardRow';
import { COLOR } from 'styles/styledComponents/color.model';

export const ScoreContainer = styled(CardRow)`
  justify-content: center;
  padding: 56px 0;
  gap: 2rem;
`;

export const CategoryIcons = styled.div`
  padding: 8px;
  border-radius: 8px;
  gap: 16px;
  border: 1px solid ${COLOR.LAVENDER};
  display: flex;
  align-items: center;
`;
